type Props = {
  collapsed?: boolean;
};

export default function ReportIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(1.1)" }}
        className={collapsed ? "" : "relative left-[3px]"}
      >
        <path
          d="M8.87561 1.44531H1.375C1.20924 1.44531 1.05027 1.51116 0.933058 1.62837C0.815848 1.74558 0.75 1.90455 0.75 2.07031V15.8203C0.75 15.9861 0.815848 16.145 0.933058 16.2623C1.05027 16.3795 1.20924 16.4453 1.375 16.4453H12.6256C12.7077 16.4453 12.789 16.4292 12.8648 16.3977C12.9406 16.3663 13.0095 16.3203 13.0676 16.2623C13.1256 16.2042 13.1716 16.1353 13.203 16.0595C13.2344 15.9837 13.2506 15.9024 13.2506 15.8203V5.82031M8.87561 1.44531L13.2506 5.82031M8.87561 1.44531V5.82031H13.2506M4.50061 12.0703H9.50061M4.50061 9.57031H9.50061"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
